import { Injectable } from '@angular/core';
import { Http, Headers, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/mergeMap';
import { forkJoin } from "rxjs/observable/forkJoin";
import { AppSettings } from "../../app.settings";
import { UUID } from "angular2-uuid";
import { SchemaPropertyNode } from "../../../components/SchemaPropertyNode";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
//import { OidcOAuthService } from "../../oidc-oauth.service";
import { Subscription } from "rxjs/Subscription";
import { map } from 'rxjs/operators';

import 'rxjs/add/operator/finally';
import { prepareProfile } from 'selenium-webdriver/firefox';
import  { InputPropertyList }  from '../../../entity-services/InputPropertyList';
import { async } from '@angular/core/testing';

@Injectable()
export class EntityConfigurationService {
  templates: Array<any> = [];
  arrayOfRelations: Array<any> = [];
  arrayOfEntity: Array<any> = [];
  entityRequiredField = ["id", "name", "type", "appname"];
  token: string;
  baseUrl: string;
  baseUrlForTimeseries: string;
  IMSTokenUrl: string;
  getData: Array<any> = [];
  accessTokenForTimeseries: string;
  public isOperationInProgress = false;

  constructor(private http: Http, private _http: HttpClient) {
    this.baseUrl = "https://qa-api.digitalvault.cloud/entity/api/v2.2";
    this.baseUrlForTimeseries = AppSettings.AdminPortalEndpoint;
    this.IMSTokenUrl = 'https://uat-api.digitalvault.cloud/Identity/ims/connect/token';
  }

  assignInputPropertyValues(properties: InputPropertyList) {

       this.token = properties.accessToken;
       if(properties.envURL){
        this.baseUrl = properties.envURL;
       }
       
  }
  
  getHeaders(headers: { key: string, value: string }[] = null): Headers {

    var headerCollection = new Headers({ 'Authorization': 'Bearer ' + this.token, "Content-Type": "application/json" });

    if (headers) {
      headers.forEach(header => {
        headerCollection.append(header.key, header.value);
      });
    }
    return headerCollection;
  }
  
  getQueryParams(queryParams: { key: string, value: string }[] = null): URLSearchParams {
    var search = new URLSearchParams();
    if (queryParams) {
      queryParams.forEach(item => {
        search.set(item.key, item.value);
      })
    }
    return search;
  }

  get(url: string, headers: { key: string, value: string }[] = null, queryParams: { key: string, value: string }[] = null): Observable<any> {
     
    var accessToken = this.token;
    var headerCollection = new Headers({ 'Authorization': 'Bearer ' + accessToken, "Content-Type": "application/json" });

    if (headers) {
      headers.forEach(header => {
        headerCollection.append(header.key, header.value);
      });
    }

    this.isOperationInProgress = true;
    return this.http
      .get(this.baseUrl + url, { headers: headerCollection, params: this.getQueryParams(queryParams) })
      .map((response: Response) => {
        return response.json();
      }
      ).catch((err: Response) => {

        this.raiseUnAuthorizedTokenError(err);
        return Observable.throw("something went wrong");
      })
      .finally(() => {
        this.isOperationInProgress = false;
      })
      ;
  }

  getForTimeSeries(url:string,headers:{key:string,value:string}[]=null,queryParams:{key:string,value:string}[]=null): Observable<any>{
    
    if (url.length > 0 && url[0] === "/")
      url = url.substr(1);
    
      
      var accessToken = this.token ; 
      console.log(accessToken);
                    
      var headerCollection = new Headers({ 'Authorization': 'Bearer ' + accessToken, "Content-Type": "application/json" });
  
      if (headers) {
        headers.forEach(header => {
          headerCollection.append(header.key, header.value);
        });
      }
      
      return  this.http
                .get(this.baseUrlForTimeseries + "/" + url, {headers: headerCollection, params:this.getQueryParams(queryParams)})
                .map((response:Response) => response.json()).catch((err: Response) => { 
                this.raiseUnAuthorizedTokenError(err);
            return Observable.throw(err);
              });
  }

  
  
  post(url: string, data: any, headers: { key: string, value: string }[] = null): Observable<any> {
    this.isOperationInProgress = true;
    return this.http
      .post(this.baseUrl, JSON.stringify(data), { headers: this.getHeaders(headers) })
      .map((response: Response) => response).catch((err: Response) => {
        this.raiseUnAuthorizedTokenError(err);
        return Observable.throw("something went wrong");
      }).finally(() => this.isOperationInProgress = false);
  }

  put(url: string, data: any): Observable<any> {

    var putData = JSON.stringify(data);
    return this.http
      .put(this.baseUrl + url, putData, { headers: this.getHeaders() })
      .map((response: Response) => response).catch((err: Response) => {
        this.raiseUnAuthorizedTokenError(err);
        return Observable.throw("something went wrong");
      }).finally(() => this.isOperationInProgress = false);
  }
  delete(url: string, headers: { key: string, value: string }[] = null): Observable<any> {
    return this.http
      .delete(this.baseUrl + "/" + url, { headers: this.getHeaders(headers) })
      .map((response: Response) => response).catch((err: Response) => {
        this.raiseUnAuthorizedTokenError(err);
        return Observable.throw(err);
      });
  }
  raiseUnAuthorizedTokenError(response: Response) {
    if (response.status === 401) {
    }
  }
  
  getSchemas(): Observable<any> {

    return this.get("/entitySchema", [{ key: "org", value: "marvel" }]);
  }


  getRelationTypes(): Observable<any> {
    return this.get("/RelationType", [{ key: "org", value: "marvel" }])
  }

  saveSchema(schemaList: any[]): Observable<any> {
    return this.getSchemas().mergeMap(response => {
      let fullSchemaList: any[] = response;
      let schemaTobeInserted = [];
      if (response) {
        let uniqueEntityTypes = schemaList.map(data => data.title).filter((x, i, a) => x && a.indexOf(x) === i);
        uniqueEntityTypes.forEach(entityType => {
          if (!fullSchemaList.find(schemaItem => schemaItem.name === entityType) &&
            !schemaTobeInserted.find(schema => schema.title === entityType)) {
            let entitySchema = schemaList.find(schema => schema.title === entityType);
            schemaTobeInserted.push(entitySchema);
          }

        });
        if (schemaTobeInserted.length === 0) {
          return Observable.throw("Schema already Exists");
        }
      }
      let entitySchemaList = [];
      schemaTobeInserted.forEach(schema => {
        this.appendAdditionalPropertyToSchema(schema);
        let entitySchema = {};
        entitySchema["id"] = UUID.UUID();
        entitySchema["type"] = "entitySchema";
        entitySchema["name"] = schema["title"];
        entitySchema["schemaData"] = schema;
        entitySchema["appname"] = "ADMINPORTAL";
        entitySchemaList.push(entitySchema);
      });
      return this.post("", entitySchemaList, [{ key: "org", value: "marvel" }]);
    }).map(res => res.json());

  }

   
  saveRelationType(relationshipTypes: any[]): Observable<any> {

    return this.getRelationTypes().mergeMap(res => {
      let relationTypes: any[] = [];
      relationshipTypes.forEach(item => {
        if (!res || !res.find(item => item.RelationType === item)) {
          relationTypes.push({
            id: UUID.UUID(),
            type: "RelationType",
            name: item,
            appname: "ADMINPORTAL"
          });
        }
      });

      return this.post("", relationTypes, [{ key: "org", value: "marvel" }]);
    })


  }

  saveEntities(entities: any[]): Observable<any> {
    entities.forEach(entity => {
      entity["appname"] = "ADMINPORTAL";
    });
    return this.post("", entities, [{ key: "org", value: "marvel" }]);
  }
  getEntitiesByEntityType(entityType: string) {
    return this.get(`/${entityType}`, [{ key: "org", value: "marvel" }])
  }
  getEntitiesById(entityType: string, id: string) {
    console.log('Entity Type:' + entityType + ' Entity Id:' + id);
    return this.get(`/${entityType}?$filter=id eq '${id}'`, [{ key: "org", value: "marvel" }])
  }

  saveRelationships(relationships: any[]): Observable<any> {

    let relations = [];
    relationships.forEach(relation => {
      relations.push({
        "id": relation["id"],
        "relationshiptype": relation["relationshiptype"],
        "sourceentityid": relation["sourceentityid"],
        "destinationentityid": relation["destinationentityid"],
        "type": "EntityRelation",
        "name": relation["relationshiptype"],
        "appname": "ADMINPORTAL",
        "sourceEntityType": relation["sourceEntityType"],
        "destinationEntityType": relation["destinationEntityType"]
      });

    });
    return this.post("", relations, [{ key: "org", value: "marvel" }]);
  }
  deleteRelationships(relationships: string[]): Observable<any> {
    return this.delete(`EntityRelation(${relationships.join(',')})`, [{ key: "org", value: "marvel" }]);
  }
  getRelationships(entityType: string): Observable<any> {
    return this.get(`/EntityRelation?$filter=relationshiptype eq '${entityType.toLowerCase()}'`, [{ key: "org", value: "marvel" }]);
  }
  getEntityRelationshipsBySourceId(sourceId: string) {

    return this.get(`/EntityRelation?$filter=sourceentityid eq '${sourceId}' or destinationentityid eq '${sourceId}'`, [{ key: "org", value: "marvel" }]);

  }
  getEntitesByRelationships(relations: any[]) {
    let listOfEntities = [];
    
    relations.forEach(relation => {
      if (!listOfEntities.find(item => item.id === relation.sourceentityid)) {
        listOfEntities.push({ id: relation.sourceentityid, type: relation.sourceEntityType });
      }
      if (!listOfEntities.find(item => item.id === relation.destinationentityid)) {
        listOfEntities.push({ id: relation.destinationentityid, type: relation.destinationEntityType });
      }
    })

    let obserableCall = listOfEntities.map(entity => this.getEntitiesById(entity.type, entity.id));
    return forkJoin(...obserableCall);
  }


  getTemplatesByType(entityTemplateType: string): Observable<any> {
    return this.get(`/EntityTemplate?filter=templatetype eq '${entityTemplateType.toLowerCase()}'`, [{ key: "org", value: "marvel" }]);
  }

  saveTemplates(template: any): Observable<any> {

    return this.getTemplatesByType(template.type).mergeMap(res => {
      let templates: any = res;
      if (!templates.find(item => item.name === res.name)) {
        template["type"] = "EntityTemplate";
        template["templatetype"] = template["type"];
        template["appname"] = "ADMINPORTAL";
        return this.post("", [template], [{ key: "org", value: "marvel" }]);
      }
    });

  }


  private appendAdditionalPropertyToSchema(finalSchema: any) {
    finalSchema["$schema"] = "http://json-schema.org/draft-06/schema#",
      finalSchema["schemaType"] = UUID.UUID();
    finalSchema["collectionId"] = UUID.UUID();
    finalSchema["description"] = `Schema for an EntityType ${finalSchema["title"]}`;
    this.entityRequiredField.forEach(field => {
      let property = finalSchema["properties"][field];
      if (!property) {
        finalSchema["properties"][field] = {
          type: "string"
        }
      }
      if (!finalSchema["required"]) {
        finalSchema["required"] = [];
      }
      finalSchema["required"].push(field);
    });
  }

  prepareAndGetValidSchemaFromEntityList(entityList: any) {
    let schemaList = [];
    let listOfEntity = [];
    if (entityList) {
      if (entityList.constructor === Object) {
        listOfEntity.push(entityList);
      }
      else {
        listOfEntity = entityList;
      }
    }
    listOfEntity.forEach(entity => {
      let schema = this.createSchemaFromUploadedJson(entity);
      if (schema) {
        schemaList.push(schema);
      }
    });
    return schemaList;
  }
  private createSchemaFromUploadedJson(jsonObj: any) {
    let schema: any;
    if (jsonObj["type"]) {
      let rootSchemaNode = new SchemaPropertyNode();
      rootSchemaNode.propType = "object";
      rootSchemaNode.propName = "root";
      rootSchemaNode.importSchemaNodeFromJsonObject(jsonObj);
      schema = rootSchemaNode.getSchema();
      schema["title"] = jsonObj["type"];
    }
    return schema;
  }

  
  
}
